import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { BENEFITS, WORKER_BG, ABSTRACT_BG, waLink } from "../lib/data";

export default function Benefits() {
  return (
    <section
      data-testid="benefits-section"
      className="relative bg-[#0A0B0E] py-24 lg:py-36 overflow-hidden"
    >
      {/* Abstract bg */}
      <div className="absolute inset-0 opacity-20">
        <img src={ABSTRACT_BG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0B0E] via-[#0A0B0E]/85 to-[#0A0B0E]/40" />
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-8">
              <span className="w-8 h-px bg-[#D4AF37]" />
              <span className="text-[#D4AF37] text-xs uppercase tracking-[0.3em]">
                ¿Por qué PPQ?
              </span>
            </div>
            <h2 className="font-display text-4xl lg:text-6xl leading-[1.05] tracking-tight text-white">
              Instalación profesional{" "}
              <span className="italic text-[#D4AF37]">con garantía real</span>.
            </h2>
            <p className="mt-8 max-w-xl text-base lg:text-lg text-white/55 font-light leading-relaxed">
              En Película y Polarizados Querétaro trabajamos con las mejores
              marcas del mercado y garantizamos cada instalación por escrito.
              Desde la medición hasta la entrega final, cuidamos cada detalle.
            </p>

            <ul className="mt-12 space-y-5">
              {BENEFITS.map((b, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  data-testid={`benefit-${i}`}
                  className="flex items-start gap-4"
                >
                  <span className="mt-1 flex-shrink-0 w-6 h-6 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/10 flex items-center justify-center">
                    <Check size={12} className="text-[#D4AF37]" strokeWidth={3} />
                  </span>
                  <span className="text-white/80 font-light leading-relaxed">{b}</span>
                </motion.li>
              ))}
            </ul>

            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="benefits-whatsapp-cta"
              className="mt-12 inline-flex items-center gap-3 px-7 py-3.5 rounded-full border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all text-sm uppercase tracking-[0.2em]"
            >
              Solicita tu cotización
              <span>→</span>
            </a>
          </div>

          {/* Right visual */}
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="relative aspect-[4/5] rounded-2xl overflow-hidden border border-white/10"
            >
              <img
                src={WORKER_BG}
                alt="Instalación profesional polarizado"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B0E] via-transparent to-transparent" />

              {/* Floating quality card */}
              <div className="absolute bottom-6 left-6 right-6 backdrop-blur-2xl bg-black/40 border border-white/10 rounded-xl p-6">
                <div className="flex items-baseline gap-3 mb-2">
                  <span className="font-display text-5xl text-[#D4AF37] italic">1+</span>
                  <span className="text-white/70 text-sm">año de garantía por escrito</span>
                </div>
                <div className="text-xs uppercase tracking-[0.2em] text-white/50">
                  Hecho para durar
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
